import { defineStore } from 'pinia';
import { collection, getDocs, addDoc, doc, updateDoc } from 'firebase/firestore';
import { db } from '../plugins/firebase'; // ✅ Correct import

export const useSubscriptionStore = defineStore('subscription', {
  state: () => ({
    subscriptions: [],
  }),

  actions: {
    /**
     * Fetch all subscriptions for the authenticated user.
     */
    async fetchSubscriptions() {
      try {
        const subscriptionsCollection = collection(db, 'subscriptions'); // ✅ Use `db` instead of `firestore`
        const snapshot = await getDocs(subscriptionsCollection);
        this.subscriptions = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    },

    /**
     * Save a new subscription.
     * @param {Object} subscriptionData - The data for the subscription.
     */
    async saveSubscription(subscriptionData) {
      try {
        const subscriptionsCollection = collection(db, 'subscriptions'); // ✅ Use `db`
        await addDoc(subscriptionsCollection, subscriptionData);
      } catch (error) {
        console.error('Error saving subscription:', error);
      }
    },

    /**
     * Cancel an existing subscription.
     * @param {string} subscriptionId - The ID of the subscription to cancel.
     */
    async cancelSubscription(subscriptionId) {
      try {
        const subscriptionDoc = doc(db, 'subscriptions', subscriptionId); // ✅ Use `db`
        await updateDoc(subscriptionDoc, { status: 'cancelled' });
      } catch (error) {
        console.error('Error cancelling subscription:', error);
      }
    },
  },
});